/* -----------------------------------------------------------------------------------------------------
  - Created: [11-04-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains Employee View Only 
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useState } from "react";
import { Grid } from '@mui/joy';
import { FaUserAlt, FaFlag, FaPenFancy, FaAddressCard, FaHashtag } from "react-icons/fa";
import { PiToolboxFill } from "react-icons/pi";
import { MdConfirmationNumber } from "react-icons/md";
import { CiMail } from "react-icons/ci";
import { CgCalendarDates } from "react-icons/cg";
import { RiLockPasswordFill } from "react-icons/ri";
import dayjs from "dayjs";
import CustomTextFieldWithIcon from "../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon";
import CustomSelectDropdown from "../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown";
import CustomDatePicker from "../../../../Components/custom_components/CustomDatePicker/CustomDatePicker";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';
import { get_workforce_by_id } from "../../../../config/Resource/workforceApis";
import { BsFillPassportFill } from "react-icons/bs";
import { ErrorToast } from "../../../../utils/toast";
import CustomStepper from "../../../../Components/CustomStepper/CustomStepper";
import ActionButton from "../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton";
import { get_designation_with_out_pagination } from "../../../../config/SettingsApis/designationApis";
import { get_roles_with_out_pagination } from "../../../../config/SettingsApis/rolesApis";
import { get_categories_with_out_pagination } from "../../../../config/SettingsApis/categorieApis";
import { get_technology_with_out_pagination } from "../../../../config/Resource/technologyApis";
import { ImPhone } from "react-icons/im";
import { statusOptions } from "../../../../utils/constants";
import { Stack } from "react-bootstrap";
import { Chip } from "@mui/material";
import CustomTooltip from "../../../../Components/custom_components/CustomTooltip/CustomTooltip";
import { get_classifications_without_pagination } from "../../../../config/SettingsApis/classificationApis";

const WorkforceFormView = () => {
    //FOR STEPPER LABELS
    const steps = ['Personal Details', 'Documents', 'Certification '];
    const isDisable = true //for disable the field
    const { userRole, userID } = useParams();
    const navigate = useNavigate()

    const [userId, setUserId] = useState(userID ? userID : null); //for get user id after a save
    const [rolesList, setRolesList] = useState([]);
    const [classificationList, setClassificationList] = useState([]);

    const [designationList, setDesignationList] = useState([]);
    const [activeStep, setActiveStep] = useState(0); // Used to control the form activeStep

    const [technologyList, SetTechnologyList] = useState([]);
    const [categoryLevelList, setCategoryLevelList] = useState([]);

    const formik = useFormik({
        initialValues: {
            UD_name: "",
            UD_StaffNo: '',
            Nationality: "",
            UD_phone: "",
            personal_phone: "",
            UD_email: "",
            LD_RoleId: '',
            UD_workforceClassificationID: '',
            UD_DesignationId: '',
            UD_address: "",
            UD_OptimaNo: "",
            UD_JoiningDate: "",
            dob: "",
            UD_ProfilePic: "",

            PassportNo: "",
            PassportIssueDate: "",
            PassportExpiryDate: "",
            EmiratesIDNo: "",
            HSE_Passport: "",
            EmiratesIDExpiry: "",
            PersonnelIDNo: "",
            LaborCardExpiry: "",
            ResidenceVisaFileNo: "",
            ResidenceVisaIssueDate: "",
            ResidenceVisaExpiryDate: '',
            LD_username: "",
            LD_password: "",

            Cicpa_Onshore: "",
            Cicpa_Onshore_expiry: "",
            Cicpa_Offshore: "",
            Cicpa_Offshore_expiry: "",
            Boseit_Expiry: "",
            Basic_H2s_Expiry: "",
            Adnoc_Medical_Exp: "",
            Adnoc_HSE_Induction: "",

            technologies: [], // FOR SAVE TECHNOLOGIES WITH CATEGORY LEVEL
            UD_status: 1,
            technology: '',
            category: '',
        },
    });

    // FETCH Roles
    const fetchRoles = async () => {
        try {
            const response = await get_roles_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Rolename,
                    value: item?.RoleID
                }));

                // Set the transformed data to the state
                setRolesList(transformedData || []);
            } else {
                setRolesList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setRolesList([]);
        }
    };

    // FETCH Classifications
    const fetchClassifications = async () => {
        try {
            const response = await get_classifications_without_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response?.data?.map((item) => ({
                    label: item?.ClassificationName,
                    value: item?.id
                }));

                // Set the transformed data to the state
                setClassificationList(transformedData || []);
            } else {
                setClassificationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setClassificationList([]);
        }
    };

    // FETCH WORKSITES 
    const fetchDesignation = async () => {
        try {
            const response = await get_designation_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Designation_Name,
                    value: item?.DesignationId
                }));

                // Set the transformed data to the state
                setDesignationList(transformedData || []);
            } else {
                setDesignationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setDesignationList([]);
        }
    };

    // // FETCH CategoryLevels 
    const fetchCategoryLevels = async () => {
        try {
            const response = await get_categories_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Name,
                    value: item?.CLL_Id
                }));

                // Set the transformed data to the state
                setCategoryLevelList(transformedData || []);
            } else {
                setCategoryLevelList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setCategoryLevelList([]);
        }
    };

    // // FETCH Technology 
    const fetchTechnology = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {

                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));
                // Set the transformed data to the state
                SetTechnologyList(transformedData || []);
            } else {
                SetTechnologyList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetTechnologyList([]);
        }
    };

    // // Handle get user information by id
    const fetchWorkforceInfoById = async (UserID) => {
        try {
            const response = await get_workforce_by_id({ UserID });
            if (response?.status === "success") {
                const {
                    UD_name,
                    UD_DesignationId,
                    UD_EmiratesIDExpiry,
                    UD_EmiratesIDNo,
                    UD_HSE_Passport,
                    UD_ID,
                    UD_JoiningDate,
                    UD_LaborCardExpiry,
                    UD_Nationality,
                    UD_OfficialMobile,
                    UD_OptimaNo,
                    UD_PassportExpiryDate,
                    UD_PassportIssueDate,
                    UD_PassportNo,
                    UD_PersonnelIDNo,
                    UD_ProfilePicPath,
                    UD_ResidenceVisaExpiryDate,
                    UD_ResidenceVisaFileNo,
                    UD_ResidenceVisaIssueDate,
                    UD_address,
                    UD_email,
                    UD_phone,
                    UD_DOB,
                    username,
                    RoleId,
                    UD_workforceClassificationID,
                    UD_status,
                    UD_StaffNo,

                    UD_Cicpa_Onshore,
                    UD_Cicpa_Onshore_expiry,
                    UD_Cicpa_Offshore,
                    UD_Cicpa_Offshore_expiry,
                    UD_Boseit_Expiry,
                    UD_Basic_H2s_Expiry,
                    UD_Adnoc_Medical_Exp,
                    UD_Adnoc_HSE_Induction,

                    technologies
                } = response?.data || {};

                const transformedData = technologies?.map((item) => ({ //FOR DESTRCTURED FOR SHOWING 
                    technology_id: item?.TechnologiesTypeId,
                    category_level_id: item?.category_level
                }));

                // Set the initialValues with the fetched data
                const initialValues = {
                    UD_name: UD_name || '',
                    UD_email: UD_email || '',
                    UD_phone: UD_phone || '',
                    OfficialMobile: UD_OfficialMobile || '',
                    UD_address: UD_address || '',
                    UD_JoiningDate: UD_JoiningDate || '',
                    UD_status: UD_status || 1,
                    UD_DesignationId: UD_DesignationId || '',
                    UD_OptimaNo: UD_OptimaNo || '',
                    UD_StaffNo: UD_StaffNo || '',
                    Nationality: UD_Nationality || '',

                    LD_RoleId: RoleId || '',
                    UD_workforceClassificationID: UD_workforceClassificationID || '',
                    // skills: '',
                    dob: UD_DOB || '',
                    UD_ProfilePic: UD_ProfilePicPath || '',

                    PassportNo: UD_PassportNo || '',
                    PassportIssueDate: UD_PassportIssueDate || '',
                    PassportExpiryDate: UD_PassportExpiryDate || '',
                    EmiratesIDNo: UD_EmiratesIDNo || '',
                    HSE_Passport: UD_HSE_Passport || '',
                    EmiratesIDExpiry: UD_EmiratesIDExpiry || '',
                    PersonnelIDNo: UD_PersonnelIDNo || '',
                    LaborCardExpiry: UD_LaborCardExpiry || '',
                    ResidenceVisaFileNo: UD_ResidenceVisaFileNo || '',
                    ResidenceVisaIssueDate: UD_ResidenceVisaIssueDate || '',
                    ResidenceVisaExpiryDate: UD_ResidenceVisaExpiryDate || '',
                    LD_username: username || '',
                    LD_password: '',

                    Cicpa_Onshore: UD_Cicpa_Onshore || '',
                    Cicpa_Onshore_expiry: UD_Cicpa_Onshore_expiry || '',
                    Cicpa_Offshore: UD_Cicpa_Offshore || '',
                    Cicpa_Offshore_expiry: UD_Cicpa_Offshore_expiry || '',
                    Boseit_Expiry: UD_Boseit_Expiry || '',
                    Basic_H2s_Expiry: UD_Basic_H2s_Expiry || '',
                    Adnoc_Medical_Exp: UD_Adnoc_Medical_Exp || '',
                    Adnoc_HSE_Induction: UD_Adnoc_HSE_Induction || '',

                    technologies: transformedData
                };

                // Manually set the form values
                formik.setValues(initialValues);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }
    };

    // FOR GET LIST
    useEffect(() => {
        fetchRoles()
        fetchClassifications()
        fetchTechnology()
        fetchDesignation();
        fetchCategoryLevels()
    }, []);

    // Increment render count each time component renders
    useEffect(() => {
        if (userId) {
            fetchWorkforceInfoById(userId)
        }
    }, [userId]);

    // Handle "Prev" button click
    const handlePrev = () => {
        setActiveStep(activeStep - 1)
    };
    const handleClose = () => {
        navigate(`/resources/workforce/list`);
    };

    // NEXT TAB CLICK WITHOUT UPDATE FORM VIA API
    const handleNextStep = (stepIndex) => {
        setActiveStep(stepIndex)
    }

    const handleNext = () => {
        if (activeStep === 0) {
            setActiveStep(activeStep + 1)
        } else if (activeStep === 1) {
            setActiveStep(activeStep + 1)
        } else {
            navigate(`/resources/workforce/list`);
        }
    }
    // Create Maps for technology and category labels
    const technologyLabel = technologyList?.length > 0
        ? new Map(technologyList?.map(item => [item.value, item.label]))
        : new Map();

    const categoryLabel = categoryLevelList?.length > 0
        ? new Map(categoryLevelList?.map(item => [item.value, item.label]))
        : new Map();

    return (
        <div>
            <Grid container columnSpacing={1} >
                {/* User Image Upload */}
                <Grid xs={12} md={12}>
                    <div className="section-border">
                        <CustomStepper activeStep={activeStep} steps={steps} handleNextStep={handleNextStep} userId={userId} />
                    </div>
                </Grid>

                {/* Personal Info Section */}
                {activeStep === 0 &&
                    <div className="section-border">
                        <Grid xs={12} md={12} className="mt-3 mb-3">
                            <div className="label-container">
                                <span className="employee-form-title">Personal Details</span>
                            </div>
                        </Grid>

                        <Grid container spacing={2}>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Full Name </span>
                                </div>

                                <CustomTooltip title={isDisable ? formik.values.UD_name : ''}>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="UD_name"
                                            name="UD_name"
                                            placeholder="Enter Full Name"
                                            value={formik.values.UD_name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.UD_name && Boolean(formik.errors.UD_name)}
                                            helperText={formik.touched.UD_name && formik.errors.UD_name}
                                            StartIcon={FaUserAlt}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </CustomTooltip>

                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Nationality
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="Nationality"
                                        name="Nationality"
                                        placeholder="Enter Nationality"
                                        value={formik.values.Nationality}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.Nationality && Boolean(formik.errors.Nationality)}
                                        helperText={formik.touched.Nationality && formik.errors.Nationality}
                                        StartIcon={FaFlag}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Staff No
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_StaffNo"
                                        name="UD_StaffNo"
                                        placeholder="Enter Staff No"
                                        value={formik.values.UD_StaffNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.UD_StaffNo && Boolean(formik.errors.UD_StaffNo)}
                                        helperText={formik.touched.UD_StaffNo && formik.errors.UD_StaffNo}
                                        StartIcon={MdConfirmationNumber}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Job Role </span>
                                </div>
                                <div className="custom-textfield-container">

                                    <CustomSelectDropdown
                                        name="LD_RoleId"
                                        placeholder="Select Role"
                                        options={rolesList}
                                        value={rolesList?.find(option => option?.value === formik?.values?.LD_RoleId) || ""}
                                        onChange={(selectedOption) => {
                                            formik.setFieldValue("LD_RoleId", selectedOption ? selectedOption.value : "");
                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.LD_RoleId && Boolean(formik.errors.LD_RoleId)}
                                        helperText={formik.touched.LD_RoleId && formik.errors.LD_RoleId}
                                        StartIcon={<PiToolboxFill />}
                                        isDisabled={isDisable}
                                        isMulti={false} // Set to false for single-select
                                        width="100%"
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Classification
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomSelectDropdown
                                        name="UD_workforceClassificationID"
                                        options={classificationList}
                                        value={classificationList?.find(opt => opt.value === formik?.values?.UD_workforceClassificationID) || null}
                                        // onChange={(option) => handleSelectChange('UD_workforceClassificationID', option)}
                                        onChange={(selectedOption) => {
                                            formik.setFieldValue("UD_workforceClassificationID", selectedOption ? selectedOption.value : "");
                                        }}
                                        placeholder="Select Classification"
                                        isClearable={false}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Designation
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomSelectDropdown
                                        name="UD_DesignationId"
                                        placeholder="Select Designation"
                                        options={designationList}
                                        value={designationList?.find(option => option?.value === formik?.values?.UD_DesignationId) || ""}
                                        onChange={(selectedOption) => {
                                            formik.setFieldValue("UD_DesignationId", selectedOption ? selectedOption.value : "");
                                        }}

                                        onBlur={formik.handleBlur}
                                        error={formik.touched.UD_DesignationId && Boolean(formik.errors.UD_DesignationId)}
                                        helperText={formik.touched.UD_DesignationId && formik.errors.UD_DesignationId}
                                        width="100%"
                                        StartIcon={<FaPenFancy />}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>



                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Official Phone Number
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="OfficialMobile"
                                        name="OfficialMobile"
                                        placeholder="Enter Official Phone Number"
                                        value={formik.values.OfficialMobile}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.OfficialMobile && Boolean(formik.errors.OfficialMobile)}
                                        helperText={formik.touched.OfficialMobile && formik.errors.OfficialMobile}
                                        StartIcon={ImPhone}
                                        isDisabled={isDisable}
                                    />

                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Personal Phone Number
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_phone"
                                        name="UD_phone"
                                        placeholder="Enter Personal Phone Number"
                                        value={formik.values.UD_phone}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.UD_phone && Boolean(formik.errors.UD_phone)}
                                        helperText={formik.touched.UD_phone && formik.errors.UD_phone}
                                        StartIcon={ImPhone}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Email </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="UD_email"
                                        name="UD_email"
                                        placeholder="Enter Email"
                                        value={formik.values.UD_email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.UD_email && Boolean(formik.errors.UD_email)}
                                        helperText={formik.touched.UD_email && formik.errors.UD_email}
                                        StartIcon={CiMail}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Address
                                        {/*  */}
                                    </span>
                                </div>
                                <CustomTooltip title={isDisable ? formik.values.UD_address : ''}>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="UD_address"
                                            name="UD_address"
                                            placeholder="Enter Address"
                                            value={formik.values.UD_address}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.UD_address && Boolean(formik.errors.UD_address)}
                                            helperText={formik.touched.UD_address && formik.errors.UD_address}
                                            StartIcon={FaAddressCard}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </CustomTooltip>

                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Joining Date
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomDatePicker
                                        name="UD_JoiningDate"
                                        onChange={(date) => formik.setFieldValue("UD_JoiningDate", date)}
                                        onBlur={formik.handleBlur}
                                        value={dayjs(formik.values.UD_JoiningDate, "DD-MM-YYYY")}
                                        error={formik.touched.UD_JoiningDate && Boolean(formik.errors.UD_JoiningDate)}
                                        helperText={formik.touched.UD_JoiningDate && formik.errors.UD_JoiningDate}
                                        StartIcon={CgCalendarDates}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">DOB
                                        {/*  */}
                                    </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomDatePicker
                                        name="dob"
                                        onChange={(date) => formik.setFieldValue("dob", date)}
                                        onBlur={formik.handleBlur}
                                        value={dayjs(formik.values.dob, "DD-MM-YYYY")}
                                        error={formik.touched.dob && Boolean(formik.errors.dob)}
                                        helperText={formik.touched.dob && formik.errors.dob}
                                        StartIcon={CgCalendarDates}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <div className="label-container">
                                    <span className="label">Status </span>
                                </div>
                                <div className="custom-textfield-container">
                                    <CustomSelectDropdown
                                        name="UD_status"
                                        placeholder="Select Status"
                                        options={statusOptions}
                                        value={statusOptions?.find(option => option?.value === formik?.values?.UD_status) || ""}
                                        onChange={(selectedOption) => {
                                            formik.setFieldValue("UD_status", selectedOption ? selectedOption.value : "");
                                        }}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.UD_status && Boolean(formik.errors.UD_status)}
                                        helperText={formik.touched.UD_status && formik.errors.UD_status}
                                        StartIcon={<FaHashtag />}
                                        isDisabled={isDisable}
                                        isMulti={false} // Set to false for single-select
                                        width="100%"
                                    />
                                </div>
                            </Grid>

                        </Grid>

                        <div className="section-border">
                            <Grid xs={12} md={12} className="mt-3 mb-3">
                                <div className="label-container">
                                    <span className="employee-form-title">Login Details</span>
                                </div>
                            </Grid>

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Username </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="LD_username"
                                            name="LD_username"
                                            placeholder="Enter Username"
                                            value={formik.values.LD_username}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.LD_username && Boolean(formik.errors.LD_username)}
                                            helperText={formik.touched.LD_username && formik.errors.LD_username}
                                            StartIcon={FaUserAlt}
                                            isDisabled={Boolean(userId)}
                                        />
                                    </div>
                                </Grid>

                                {!Boolean(userId) && <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Password <span className='label_required_remark'>*</span></span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomTextFieldWithIcon
                                            id="LD_password"
                                            name="LD_password"
                                            placeholder="Enter Password"
                                            value={formik.values.LD_password}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.LD_password && Boolean(formik.errors.LD_password)}
                                            helperText={formik.touched.LD_password && formik.errors.LD_password}
                                            StartIcon={RiLockPasswordFill}
                                        />
                                    </div>
                                </Grid>}

                            </Grid>
                        </div>
                    </div>}

                {/* Documents  Section */}
                {activeStep === 1 && <div className="section-border">

                    <Grid xs={12} md={12} className="mt-3 mb-3">
                        <div className="label-container">
                            <span className="employee-form-title">Documents Details</span>
                        </div>
                    </Grid>

                    <Grid container spacing={2}>

                        {/* PASSPORT SECTION START */}
                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <CustomTooltip title={isDisable ? formik.values.PassportNo : ''}>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="PassportNo"
                                        name="PassportNo"
                                        placeholder="Enter Passport No"
                                        value={formik.values.PassportNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.PassportNo && Boolean(formik.errors.PassportNo)}
                                        helperText={formik.touched.PassportNo && formik.errors.PassportNo}
                                        StartIcon={BsFillPassportFill}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </CustomTooltip>

                        </Grid>
                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport Issue Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="PassportIssueDate"
                                    onChange={(date) => formik.setFieldValue("PassportIssueDate", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.PassportIssueDate, "DD-MM-YYYY")}
                                    error={formik.touched.PassportIssueDate && Boolean(formik.errors.PassportIssueDate)}
                                    helperText={formik.touched.PassportIssueDate && formik.errors.PassportIssueDate}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>
                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Passport Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="PassportExpiryDate"
                                    onChange={(date) => formik.setFieldValue("PassportExpiryDate", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.PassportExpiryDate, "DD-MM-YYYY")}
                                    error={formik.touched.PassportExpiryDate && Boolean(formik.errors.PassportExpiryDate)}
                                    helperText={formik.touched.PassportExpiryDate && formik.errors.PassportExpiryDate}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>
                        {/* PASSPORT SECTION END */}

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">HSE Passport No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <CustomTooltip title={isDisable ? formik.values.EmiratesIDNo : ''}>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="HSE_Passport"

                                        name="HSE_Passport"
                                        placeholder="Enter HSE Passport No"
                                        value={formik.values.HSE_Passport}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.HSE_Passport && Boolean(formik.errors.HSE_Passport)}
                                        helperText={formik.touched.HSE_Passport && formik.errors.HSE_Passport}
                                        StartIcon={MdConfirmationNumber}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </CustomTooltip>

                        </Grid>

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Emirates ID No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <CustomTooltip title={isDisable ? formik.values.EmiratesIDNo : ''}>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="EmiratesIDNo"
                                        name="EmiratesIDNo"
                                        placeholder="Enter Emirates ID No"
                                        value={formik.values.EmiratesIDNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.EmiratesIDNo && Boolean(formik.errors.EmiratesIDNo)}
                                        helperText={formik.touched.EmiratesIDNo && formik.errors.EmiratesIDNo}
                                        StartIcon={MdConfirmationNumber}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </CustomTooltip>

                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Emirates ID Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="EmiratesIDExpiry"
                                    onChange={(date) => formik.setFieldValue("EmiratesIDExpiry", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.EmiratesIDExpiry, "DD-MM-YYYY")}
                                    error={formik.touched.EmiratesIDExpiry && Boolean(formik.errors.EmiratesIDExpiry)}
                                    helperText={formik.touched.EmiratesIDExpiry && formik.errors.EmiratesIDExpiry}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Personnel ID No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <CustomTooltip title={isDisable ? formik.values.PersonnelIDNo : ''}>
                                <div className="custom-textfield-container">
                                    <CustomTextFieldWithIcon
                                        id="PersonnelIDNo"
                                        name="PersonnelIDNo"
                                        placeholder="Enter Personnel ID No"
                                        value={formik.values.PersonnelIDNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.PersonnelIDNo && Boolean(formik.errors.PersonnelIDNo)}
                                        helperText={formik.touched.PersonnelIDNo && formik.errors.PersonnelIDNo}
                                        StartIcon={MdConfirmationNumber}
                                        isDisabled={isDisable}
                                    />
                                </div>
                            </CustomTooltip>

                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Labor Card Expiry
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="LaborCardExpiry"
                                    onChange={(date) => formik.setFieldValue("LaborCardExpiry", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.LaborCardExpiry, "DD-MM-YYYY")}
                                    error={formik.touched.LaborCardExpiry && Boolean(formik.errors.LaborCardExpiry)}
                                    helperText={formik.touched.LaborCardExpiry && formik.errors.LaborCardExpiry}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa File No
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="ResidenceVisaFileNo"
                                    name="ResidenceVisaFileNo"
                                    placeholder="Enter Residence Visa File No"
                                    value={formik.values.ResidenceVisaFileNo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.ResidenceVisaFileNo && Boolean(formik.errors.ResidenceVisaFileNo)}
                                    helperText={formik.touched.ResidenceVisaFileNo && formik.errors.ResidenceVisaFileNo}
                                    StartIcon={MdConfirmationNumber}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa Issue Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="ResidenceVisaIssueDate"
                                    onChange={(date) => formik.setFieldValue("ResidenceVisaIssueDate", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.ResidenceVisaIssueDate, "DD-MM-YYYY")}
                                    error={formik.touched.ResidenceVisaIssueDate && Boolean(formik.errors.ResidenceVisaIssueDate)}
                                    helperText={formik.touched.ResidenceVisaIssueDate && formik.errors.ResidenceVisaIssueDate}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>

                        <Grid xs={12} md={4}>
                            <div className="label-container">
                                <span className="label">Residence Visa Expiry Date
                                    {/* <span className='label_required_remark'>*</span> */}
                                </span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomDatePicker
                                    name="ResidenceVisaExpiryDate"
                                    onChange={(date) => formik.setFieldValue("ResidenceVisaExpiryDate", date)}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.ResidenceVisaExpiryDate, "DD-MM-YYYY")}
                                    error={formik.touched.ResidenceVisaExpiryDate && Boolean(formik.errors.ResidenceVisaExpiryDate)}
                                    helperText={formik.touched.ResidenceVisaExpiryDate && formik.errors.ResidenceVisaExpiryDate}
                                    StartIcon={CgCalendarDates}
                                    isDisabled={isDisable}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>}

                {/*  Certification  section start*/}
                {activeStep === 2 &&
                    <>
                        <div className="section-border">
                            <Grid xs={12} md={12} className="mt-3 mb-3">
                                <div className="label-container">
                                    <span className="employee-form-title">Certification Details

                                    </span>
                                </div>
                            </Grid>

                            <Grid container spacing={2}>

                                <Grid xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">OPTIMA No
                                            {/*  */}
                                        </span>
                                    </div>
                                    <CustomTooltip title={isDisable ? formik.values.UD_OptimaNo : ''}>
                                        <div className="custom-textfield-container">
                                            <CustomTextFieldWithIcon
                                                id="UD_OptimaNo"
                                                name="UD_OptimaNo"
                                                placeholder="Enter OPTIMA No"
                                                value={formik.values.UD_OptimaNo}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.UD_OptimaNo && Boolean(formik.errors.UD_OptimaNo)}
                                                helperText={formik.touched.UD_OptimaNo && formik.errors.UD_OptimaNo}
                                                StartIcon={MdConfirmationNumber}
                                                isDisabled={isDisable}
                                            />
                                        </div>
                                    </CustomTooltip>

                                </Grid>

                                {/* CICPA On Shore No */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA On Shore No
                                            {/*  */}
                                        </span>
                                    </div>
                                    <CustomTooltip title={isDisable ? formik.values.Cicpa_Onshore : ''}>
                                        <div className="custom-textfield-container">
                                            <CustomTextFieldWithIcon
                                                id="Cicpa_Onshore"
                                                name="Cicpa_Onshore"
                                                placeholder="Enter CICPA On Shore No"
                                                value={formik.values.Cicpa_Onshore}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.Cicpa_Onshore && Boolean(formik.errors.Cicpa_Onshore)}
                                                helperText={formik.touched.Cicpa_Onshore && formik.errors.Cicpa_Onshore}
                                                StartIcon={MdConfirmationNumber}
                                                isDisabled={isDisable}
                                            />
                                        </div>
                                    </CustomTooltip>

                                </Grid>

                                {/* CICPA Onshore Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Onshore Expiry Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Cicpa_Onshore_expiry"
                                            onChange={(date) => {
                                                formik.setFieldValue('Cicpa_Onshore_expiry', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Cicpa_Onshore_expiry, 'DD-MM-YYYY')}
                                            error={formik.touched.Cicpa_Onshore_expiry && Boolean(formik.errors.Cicpa_Onshore_expiry)}
                                            helperText={formik.touched.Cicpa_Onshore_expiry && formik.errors.Cicpa_Onshore_expiry}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>

                                {/* CICPA Off Shore No */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Off Shore No
                                            {/*  */}
                                        </span>
                                    </div>
                                    <CustomTooltip title={isDisable ? formik.values.Cicpa_Offshore : ''}>
                                        <div className="custom-textfield-container">
                                            <CustomTextFieldWithIcon
                                                id="Cicpa_Offshore"
                                                name="Cicpa_Offshore"
                                                placeholder="Enter CICPA Off Shore No"
                                                value={formik.values.Cicpa_Offshore}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.Cicpa_Offshore && Boolean(formik.errors.Cicpa_Offshore)}
                                                helperText={formik.touched.Cicpa_Offshore && formik.errors.Cicpa_Offshore}
                                                StartIcon={MdConfirmationNumber}
                                                isDisabled={isDisable}
                                            />
                                        </div>
                                    </CustomTooltip>

                                </Grid>

                                {/* CICPA Off Shore Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">CICPA Off Shore Expiry Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Cicpa_Offshore_expiry"
                                            onChange={(date) => {
                                                formik.setFieldValue('Cicpa_Offshore_expiry', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Cicpa_Offshore_expiry, 'DD-MM-YYYY')}
                                            error={formik.touched.Cicpa_Offshore_expiry && Boolean(formik.errors.Cicpa_Offshore_expiry)}
                                            helperText={formik.touched.Cicpa_Offshore_expiry && formik.errors.Cicpa_Offshore_expiry}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>

                                {/* Bosexit Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Bosexit Expiry Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Boseit_Expiry"
                                            onChange={(date) => {
                                                formik.setFieldValue('Boseit_Expiry', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Boseit_Expiry, 'DD-MM-YYYY')}
                                            error={formik.touched.Boseit_Expiry && Boolean(formik.errors.Boseit_Expiry)}
                                            helperText={formik.touched.Boseit_Expiry && formik.errors.Boseit_Expiry}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>

                                {/* Basic H2S Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">Basic H2S Expiry Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Basic_H2s_Expiry"
                                            onChange={(date) => {
                                                formik.setFieldValue('Basic_H2s_Expiry', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Basic_H2s_Expiry, 'DD-MM-YYYY')}
                                            error={formik.touched.Basic_H2s_Expiry && Boolean(formik.errors.Basic_H2s_Expiry)}
                                            helperText={formik.touched.Basic_H2s_Expiry && formik.errors.Basic_H2s_Expiry}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>

                                {/* ADNOC Medical Expiry Date */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">ADNOC Medical Expiry Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Adnoc_Medical_Exp"
                                            onChange={(date) => {
                                                formik.setFieldValue('Adnoc_Medical_Exp', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Adnoc_Medical_Exp, 'DD-MM-YYYY')}
                                            error={formik.touched.Adnoc_Medical_Exp && Boolean(formik.errors.Adnoc_Medical_Exp)}
                                            helperText={formik.touched.Adnoc_Medical_Exp && formik.errors.Adnoc_Medical_Exp}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>

                                {/* ADNOC HSE Induction */}
                                <Grid item xs={12} md={4}>
                                    <div className="label-container">
                                        <span className="label">ADNOC HSE Induction Date
                                            {/*  */}
                                        </span>
                                    </div>
                                    <div className="custom-textfield-container">
                                        <CustomDatePicker
                                            name="Adnoc_HSE_Induction"
                                            onChange={(date) => {
                                                formik.setFieldValue('Adnoc_HSE_Induction', date);
                                            }}
                                            onBlur={formik.handleBlur}
                                            value={dayjs(formik.values.Adnoc_HSE_Induction, 'DD-MM-YYYY')}
                                            error={formik.touched.Adnoc_HSE_Induction && Boolean(formik.errors.Adnoc_HSE_Induction)}
                                            helperText={formik.touched.Adnoc_HSE_Induction && formik.errors.Adnoc_HSE_Induction}
                                            StartIcon={CgCalendarDates}
                                            isDisabled={isDisable}
                                        />
                                    </div>
                                </Grid>
                                <Grid xs={12} md={4}>  </Grid>
                            </Grid>
                        </div>

                        {formik?.values?.technologies?.length > 0 && (

                            <div className="section-border" style={{ width: '100%', margin: 'auto' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div className="label-container">
                                            <span className="employee-form-title">Skills</span>
                                        </div>
                                    </Grid>

                                    {/* Right side: Technologies */}
                                    <Grid item xs={12} sm={12} md={6}>
                                        <div className="added-technologies">
                                            <Stack
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    gap: '1rem',
                                                    flexWrap: 'wrap'  // Allow wrapping on smaller screens
                                                }}
                                            >
                                                {formik?.values?.technologies?.map((tech, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={`${technologyLabel?.get(tech.technology_id) || 'Unknown'} (${categoryLabel?.get(tech.category_level_id) || 'Unknown'})`}
                                                        variant="outlined"
                                                    />
                                                ))}
                                            </Stack>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>

                        )}

                    </>
                }
            </Grid>


            {/* Action Buttons */}
            <div className='form-bottom-action-buttons-container'>
                <ActionButton onClick={handleClose} label="Close" btnType="outlined" />
                {activeStep !== 0 && <ActionButton onClick={handlePrev} label="Previous" btnType="primary" />}
                {/* ADDED FOR Next Button is Hide. */}
                {activeStep !== 2 && <ActionButton
                    onClick={handleNext}
                    label={activeStep === 2 ? `Next` : ` Next`} btnType="primary" />}
            </div>

        </div>
    );
};

export default WorkforceFormView;
